import { render, staticRenderFns } from "./eidtDetail.vue?vue&type=template&id=eed60ecc&scoped=true"
import script from "./eidtDetail.vue?vue&type=script&lang=js"
export * from "./eidtDetail.vue?vue&type=script&lang=js"
import style0 from "./eidtDetail.vue?vue&type=style&index=0&id=eed60ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed60ecc",
  null
  
)

export default component.exports